import { ReactElement } from 'react';
import { Flex, Grid, Layout } from 'antd';
import { StyledLayout } from '@lib/theme/components/Layout';

const { Content } = Layout;

const PublicVoteWrapper = ({ children }: { children: ReactElement }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <StyledLayout>
      <Flex
        style={{
          height: '100%',
        }}
      >
        <Content
          style={{
            background: '#F4F7F9',
            marginTop: 32,
            marginInlineStart: screens.lg ? 32 : 16,
            marginInlineEnd: screens.lg ? 32 : 16,
          }}
        >
          {children}
        </Content>
      </Flex>
    </StyledLayout>
  );
};

export default PublicVoteWrapper;
